module.exports = __webpack_public_path__ + "img/dots.0a3ef405.svg";